import React from "react";
import {defineBlock, smartProps, useEditor, useSmartProp, useInspectorControl} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, ToggleControl, SelectControl, TextControl  } from '@wordpress/components';
import { Button } from '../shared/utils';
import style from "./block.module.scss";

function Inspector(){
    const [buttonColor, setButtonColor] = useSmartProp("buttonColor");
    const [buttonUrl, setButtonUrl] = useSmartProp("buttonUrl");
    const [button1Popup, setButton1Popup] = useSmartProp("button1Popup");
    const [button1Target, setButton1Target] = useSmartProp("button1Target");
    const [hasPhoneIcon, setHasPhoneIcon] = useSmartProp("hasPhoneIcon");

    return <PanelBody title="Styles" initialOpen={true}>
                <PanelRow>
                    <SelectControl
                        label="Button color"
                        value={buttonColor}
                        options={[
                                { value: 'blue', label: 'Blue', selected: true },
                                { value: 'transparent', label: 'Transparent' },
                            ]}
                        onChange={(buttonColor) =>setButtonColor(buttonColor)}
                    />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label="Button URL"
                        value={buttonUrl}
                        onChange={(buttonUrl) =>setButtonUrl(buttonUrl)}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label="Show phone icon"
                        checked={hasPhoneIcon}
                        onChange={() =>setHasPhoneIcon(!hasPhoneIcon)}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label="Open in a new window"
                        checked={button1Target}
                        onChange={() =>setButton1Target(!button1Target)}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label="Display of the confirmation popup"
                        checked={button1Popup}
                        onChange={() =>{
                            if(button1Popup) { 
                                setButton1Popup(false);
                            }
                            else{
                                setButton1Popup(true);
                            }
                        }}
                    />
                </PanelRow>
            </PanelBody>
}

function Block({buttonColor, buttonUrl, button1Target, button1Popup, hasPhoneIcon}){
    useInspectorControl(Inspector);
    const {isEditing} = useEditor();

    buttonColor = buttonColor !== '' ? buttonColor : 'blue';

    return <Button additionalClassName={style.block + " " + style[buttonColor]} className={buttonColor} buttonText="button1Text" hasPhoneIcon={hasPhoneIcon} url={buttonUrl} blank={button1Target} popup={button1Popup} isEditing={isEditing}/>
}

export default defineBlock({
    Block,
    smartProps: {
        buttonColor: smartProps.string.withDefault(""),
        button1Text: smartProps.string.withDefault(""),
        button1Target: smartProps.bool.withDefault(""),
        button1Popup: smartProps.bool.withDefault(""),
        buttonUrl: smartProps.string.withDefault(),
        hasPhoneIcon: smartProps.bool.withDefault(false),
    },
    setup: {
        title: "Button style 1",
        parent: ["smartfire/image-texte", "smartfire/bloc-container"],
        category: "two-third",
    }
});